import { combineReducers } from "redux";
import all_trade from "../features/admin/all_trade/slice";

const AllTradeData = combineReducers({
  all_trade: all_trade,
});

export default AllTradeData;
